import {styled} from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import FormControlLabel from '@mui/material/FormControlLabel';
import Arrow from 'assets/img/ex-acc.svg';

const Accordion = styled((props) => <MuiAccordion disableGutters {...props} />)(
  ({theme}) => ({
    width: '100%',
    backgroundColor: '#f5f5f5',
    borderRadius: '16px !important',
    boxShadow: '5px 5px 10px rgba(174, 174, 192, 0.20), -4px -4px 15px #FFFFFF',
    border: '1px solid #FFFFFF ',
  })
);
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<img src={Arrow} alt='' />} {...props} />
))(({theme}) => ({
  borderRadius: '16px',
  backgroundColor: '#f5f5f5',
  flexDirection: 'row-reverse',
  '&.Mui-expanded': {
    borderRadius: '16px 16px 0 0',
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
}));
const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
  backgroundColor: '#f5f5f5',
  borderRadius: '0 0 16px 16px !important',
  border: 0,
  paddingBottom: 0,
  borderTop: 'none',
}));
const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({theme, activeItem}) => ({
  '.MuiFormControlLabel-label': {
    fontFamily: 'dana-bold',
    fontSize: '0.875rem',
    color: activeItem ? '#753CBE' : '#707070',
  },
}));

export {StyledFormControlLabel, AccordionDetails, AccordionSummary, Accordion};
